import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import { usePostHog } from 'posthog-js/react';

import EmailAuthForm from '@/pages/Onboarding/components/EmailAuthForm/EmailAuthForm';
import { Product, getTheme, getLob } from '@/utils/productHelpers';
import { activateEmail } from '@/utils/sparkActivationApi';
import { ACCESS_CODE_SESSION_KEY } from '@/utils/constants';

interface EmailAuthLocationState {
  accessCode?: string;
  organizationSlug?: string;
}

const EmailAuthPage: React.FC = () => {
  const history = useHistory();
  const { product } = useParams<{ product: Product }>();
  const { state: locationState } = useLocation<EmailAuthLocationState>();
  const posthog = usePostHog();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    posthog?.capture('SignUpEmailLanded');
  }, [posthog]);

  const handleSubmit = async (email: string) => {
    posthog?.capture('SignUpEmailMethodClicked', { email, input: email });
    setLoading(true);
    try {
      if (locationState?.accessCode) {
        sessionStorage.setItem(ACCESS_CODE_SESSION_KEY, locationState.accessCode);
      }

      await activateEmail({
        email,
        product,
        accessCode: locationState?.accessCode,
        organizationSlug: locationState?.organizationSlug,
        lob: getLob(locationState?.organizationSlug),
      });

      posthog?.capture('SignUpEmailMagicSent', { email, input: email });

      history.push(`/activate/${product}/check-email`, {
        email,
        accessCode: locationState?.accessCode,
        organizationSlug: locationState?.organizationSlug,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <ThemeProvider theme={getTheme(product)}>
      <EmailAuthForm onSubmit={handleSubmit} loading={loading} />
    </ThemeProvider>
  );
};

export default EmailAuthPage;
